<template>
  <div id="global-comment" class="end-page page">
    <div class="illustration"></div>
    <div class="title">{{ $t('report.exportConclusion') }}</div>

    <div class="container" v-html="formatedComment"></div>

    <div class="footer">
      <div class="focus" :class="{ show: filters }">{{ $t('focusStudyOn') }} : {{ filters }}</div>
      <div class="right-container">
        <div class="logo-line">
          <div class="jll-logo"></div>
          <div class="divider-vertical"></div>
          <div class="commuter-logo">Commuter</div>
        </div>
        <div class="page-number" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CommentPage',

  props: {
    comment: {
      type: String,
      required: false,
      default: '',
    },

    filters: {
      type: String,
      required: false,
      default: null,
    },

    disableCount: {
      type: [Boolean, Number],
      required: false,
      default: false,
    },
  },

  data() {
    return {
      currentPage: 0,
    };
  },

  computed: {
    ...mapGetters({ totalPages: 'totalPages' }),

    formatedComment() {
      return this.comment ? this.comment.replaceAll('\n', '<br/>') : '';
    },
  },

  mounted() {
    if (!this.disableCount) {
      this.currentPage = Number(this.totalPages + 1);
      this.$store.dispatch('setPage');
    } else {
      this.currentPage = this.disableCount;
    }
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';

.end-page {
  padding: 48px 80px;
  box-sizing: border-box;
  position: relative;

  .illustration {
    position: absolute;
    top: -70%;
    right: 70%;
    bottom: -25%;
    left: -75%;
    transform: rotate(5deg);
    opacity: 0.1;
    background-image: url('./../../assets/JLL-Brush.png');
    background-repeat: no-repeat;
    background-position: center right;
    background-size: cover;
  }

  .title {
    display: flex;
    flex-direction: column;
    font-size: 32px;
    font-weight: 600;
    color: #3c3c3b;
    margin-bottom: 16px;

    &::after {
      content: '';
      margin: 8px 0;
      width: 64px;
      height: 4px;
      border-radius: 4px;
      background: colors.$main-color;
    }
  }

  .container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8px 24px 16px;
    box-sizing: border-box;

    max-width: calc(100% - 128px);
    margin: 0 auto;
    text-align: justify;

    .logo {
      width: 512px;
      height: 256px;
      background-image: url('../../assets/CommuterLogo-Black.svg');
      background-repeat: no-repeat;
      background-size: contain;
    }
  }

  .footer {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    color: #9b9b9b;
    padding: 16px 24px 16px 64px;
    font-size: 0.8em;

    .focus {
      opacity: 0;

      &.show {
        opacity: 1;
      }
    }

    .right-container {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .logo-line {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .jll-logo {
          width: 64px;
          height: 24px;
          margin: 0;

          background-image: url('./../../assets/JLLLogo-Color.png');
          background-repeat: no-repeat;
          background-position: center right;
          background-size: cover;
        }

        .divider-vertical {
          width: 1px;
          height: 16px;
          border-radius: 2px;
          margin: 2px 16px -2px 12px;
          background: #9b9b9b;
        }

        .commuter-logo {
          font-size: 20px;
          color: colors.$stone-color;
          font-family: 'Golden Plains';
        }
      }
    }

    .page-number {
      text-align: right;
      width: 32px;
      color: #3c3c3b;
    }
  }
}
</style>
